module.exports = __webpack_public_path__ + "img/video-thumb-10-nl.7ca5aaf1.png";